import React from 'react';

const Loader = () => {
  return (
    <div className="preloader">
      <div className="status">
        <div className="bouncing-loader">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
